// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"FinanceSetting--next-sr-only--pJoFNDp","settingH2":"FinanceSetting--settingH2--23BOOHR"};